import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {MenuItem, Table, Chip} from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TablePagination from "@material-ui/core/TablePagination"; 
import Paper from "@material-ui/core/Paper";
import PropTypes from "prop-types";
import Skeleton from '@mui/material/Skeleton';
import { useDispatch, useSelector } from "react-redux";
import {getTasksForUser, claimTask, unclaimTask, getTask} from "../../store/action/taskAction";
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDots } from "react-icons/bs";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import './TaskList.css'
import { useNavigate } from "react-router-dom";
import {fetchUser} from "../../store/action/user";
import { hasAuthorities } from "../../utils/authoritiesUtils";
import { fetchMessageEvents } from "../../store/action/communicationChannel";
import { translateTaskName } from "../../utils/translateTaskName";
import getDateTimeFromString from "../../utils/getDateTimeFromString";
function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
    const classes = useStyles();
   const { order, orderBy, onRequestSort } = props;

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    const headRows = [
        {
            id: "businessKey",
            align: "left",
            label: "N° Sinistre",
            width: "15%",
        },
        {
            id: "immatriculation",
            align: "left",
            label: "Immatriculation",
            width: "15%",
        },
        {
            id: "assignee",
            align: "left",
            label: "Responsable",
            width: "20%",
        },
        {
            id: "managementType",
            align: "left",
            label: "Mode de gestion",
            width: "20%",
        },
        {
            id: "creationDate",
            align: "left",
            label: "Date création",
            width: "20%",
        },
        {
            id: "taskName",
            align: "left",
            label: "Action",
            width: "40%",
        },
    ];

    return (
        <tr className={classes.tableHeadRows} >
            
            {headRows.map((row) => (
                 <TableCell
                 key={row.id}
                 align={row.align}
                 sortDirection={orderBy === row.id ? order : false}
                 style={{ border: 0 }}
             >
               <TableSortLabel
                   active={true}
                   direction={orderBy === row.id ? order : "desc"}
                   onClick={createSortHandler(row.id)}
                   style={{
                     whiteSpace: "nowrap",
                     fontFamily: "Poppins",
                     fontWeight: 600,
                     fontSize: 12,
                     lineHeight: "18px",
                     color: "rgba(181, 181, 195, 1)",
                   }}
               >
                 {row.label}
               </TableSortLabel>
             </TableCell>
            ))}
            <TableCell align="left"  style={{border : 0}} >
                {" "}
            </TableCell>
        </tr>    );
}


const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        minHeight: "85vh" 
    },
    tableCellSmall: {
        fontFamily : 'Poppins',
        fontWeight : 600,
        fontSize :14,
        lineHeight:'21px',
        color :'rgba(70, 78, 95, 1)',
        borderBottom: '1px solid  rgba(0, 0, 0, 0.08)'
    },
    paper: {
        width: "100%",
        borderRadius : '11px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)'
    },
    tableWrapper: {
        padding :'40px'
    },
    tableHeadRows: {
        background: 'rgba(250, 250, 250, 1)',
        width: '191px',
        height: '53px',
        padding: '18px 16px',
        gap: '8px',
        color: 'rgba(32, 29, 35, 1)'
    },
    tableSortLabel:{
        color: 'rgba(32, 29, 35, 1)',
        fontFamily : 'Inter',
        fontWeight : 400 ,
        fontSize :12,
        lineHeight:'18px'
    },
    titre :{
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 600,
        color: 'rgba(63, 66, 84, 1)',
    },
    titreLabel :{
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 400,
        color: 'rgba(32, 18, 70, 1)',
    },
    tablePagination:{
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '18px',
        color :'rgba(32, 18, 70, 1)'
    },
    dateRangeContainer: {
        display: "flex",
        alignItems: "center",
        border: "0.61px solid rgba(226, 217, 239, 1)",
        background: "rgba(255, 255, 255, 1)",
        borderRadius: 5,
        padding: "5px 10px",
      },
      dateContainer: {
        border: "none",
        outline: "none",
        background: "transparent",
        borderRadius: 5,
        fontFamily: "Poppins",
        paddingLeft: "5px",
      },
    inputContainer: {
        border: '0.61px solid rgba(226, 217, 239, 1)',
        background: 'rgba(255, 255, 255, 1)',
        width: '148px',
        height: '29.69px',
        borderRadius: 5,
        marginLeft: '20px',
    },
    viewBtn: {
        width: '40px',
        height: '34px',
        borderRadius: '6px',
        backgroundColor:'rgba(240, 243, 199, 1)',
        border: 0,
        lineHeight: '18px',
        color: 'rgba(187, 200, 8, 1)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    taskNameColumn: {
        width: '100%',
        height: '100%',
        gap: '0px',
        fontFamily: 'Poppins',
        fontSize: '10.17px',
        fontWeight: 500,
        textAlign: 'left',
        color: 'rgba(187, 200, 8, 1)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    tableContent:{
        fontFamily: 'Inter',
        fontSize: 14,
        fontWeight: 400,
        //lineHeight: 19.6,
        textAlign: 'left',
        color: 'rgba(32, 29, 35, 0.8)',
        paragraph: {
            lineHeight: '32.69px',
        },
},
    sinistres: {
        fontFamily: 'Poppins',
        fontSize: 14,
        fontWeight: 600,
        textAlign: 'left',
        color: 'rgba(70, 78, 95, 1)',
    },
    dropdownMenu: {
        position: 'absolute',
        zIndex: 1,
        backgroundColor: 'white',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        //boxShadow: theme.shadows[5],
        marginRight: "110px",
        borderRadius:6,
    },
    dropdownItem: {
        padding: theme.spacing(1),
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        color: 'rgba(32, 18, 70, 1)',
        fontFamily: 'Poppins',
        fontSize: '10px',
        fontWeight: 400,
        textAlign: 'left',
    },
    naText: {
        color: 'rgb(145, 145, 145)',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

    },
    paperModal:{
        backgroundColor: 'rgba(255, 255, 255, 1)',
        border: 'none',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
        padding: theme.spacing(2, 4, 3),
        width: '459px',
        height: '175px',
    },
    modalTitle:{
        fontFamily: 'Poppins',
        fontSize: '18px',
        fontWeight: 500,
        lineHeight: '21px',
        textAlign: 'left',
        marginBottom: '16px',
    },
    line: {
        height: '2px',
        backgroundColor: 'rgba(243, 246, 249, 1)',
        width: '100%',
        marginBottom: '16px',
    },
    selectModal: {
        width: '400px',
        height: '36px',
        borderRadius: '4px',
        border: '1px solid rgba(222, 222, 222, 1)',
    },
    optionItem: {
        width: '150px',
        padding: theme.spacing(1),
        cursor: 'pointer',
        backgroundColor: 'white',
        color: 'rgba(32, 18, 70, 1)',
        fontFamily: 'Poppins',
        fontSize: '10px',
        fontWeight: 400,
        textAlign: 'left',
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      },
      todoListActions: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: 100,
        textAlign:'center'
        
    },
    todoSection: {
        flex: 1,
        height: 87,
        padding: 10,
        backgroundColor: 'rgba(255, 255, 255, 1)',
        border: '1px solid rgba(255, 255, 255, 1)',
        opacity: 1,
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '18px',
        color: 'rgba(181, 181, 195, 1)',
        position: 'relative',
        paddingTop: 20,
        paddingBottom:10,
        paddingLeft: 17,
    //     textAlign: 'justify',
    // textJustify: 'inter-word'
    },
    firstSection: {
        borderTopLeftRadius: 9,
        borderBottomLeftRadius: 9,
        paddingTop: 20,
        cursor: 'pointer'
    },
    lastSection: {
        borderTopRightRadius: 9,
        borderBottomRightRadius: 9,
        paddingTop: 20,
        cursor: 'pointer'
    },
    sectionLine: {
        content: '""',
        position: 'absolute',
        top: 7,
        bottom: 5,
        right: 0,
        width: 1,
        backgroundColor: 'rgba(244, 241, 249, 1)',
    },
    sectionText: {
        fontFamily: 'Poppins',
        fontSize: 20,
        fontWeight: 600,
        color: 'rgba(70, 78, 95, 1)',
        display: 'block',
        paddingLeft: 0,
        marginTop: 5,
    },
    managementTypeChip: {
        backgroundColor: 'rgba(240, 243, 199, 1)',
        color: 'rgba(60, 101, 86, 1)',
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontWeight: 500,
        height: '24px',
        borderRadius: '4px',
        width: '120px',
        '& .MuiChip-label': {
            padding: '0 8px',
            width: '100%',
            textAlign: 'center'
        }
    },
}));

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number,
    numSelected: PropTypes.number.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
};
 
export default function TaskList(props) {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("");
    const [selected, setSelected] = useState([]);
    const [inputType, setInputType] = useState('text'); // (for date field)
    const { taskList, pagination } = useSelector((state) => state.taskReducer);
    const [loading, setLoading] = useState(true);
    const [dateRange, setDateRange] = useState({ fromDate: null, toDate: null });
    const [responsible, setResponsible] = useState('');
    const [taskName, setTaskName] = useState('');
    const [claimNumber, setClaimNumber] = useState('');
    const [immatriculation, setImmatriculation] = useState('');
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [currentTaskId, setCurrentTaskId] = useState(null);
    const navigate = useNavigate();
    const [messageEvents, setMessageEvents] = useState({});

    const username = localStorage.getItem('username');

    const Groups = JSON.parse(localStorage.getItem('groupAuthorities') || '[]');
    const userGroups =  ([
        username,
        
      ]); 
    
    const user = useSelector(state => state.user.user);
    
const excludeIds = [
  'STEP_CLAIM_HORS_IDA_ELIGIBLE_FOR_MANAGEMENT',
  'STEP_CLAIM_NOT_ELIGIBLE_FOR_PAYMENT',
  'STEP_CLAIM_WITH_INSPECTION_AWAITING_RECEIPT',
  'STEP_MINUS_500_AWAITING_PAYMENT',
  'STEP_BDG_CLAIM_AWAITING_RECEIPT',
  'STEP_INSERT_CLAIM_ERECOURS'
];

 
 
  const handleViewClick = (task) => {
    setCurrentTaskId(task.taskId);

    const taskDefinitionId = task.taskDefinitionId 
    let route = '';
    props.setTaskId(task.taskId);
    switch (taskDefinitionId) {
    
      case "STEP_DESIGNATE_PARTIES":
        route = `/designate-parties/${task.taskId}`;
        break;
      case "STEP_DESIGNATE_INSPECTOR":
        route = `/designate-parties/${task.taskId}`;
        break;
      case "STEP_DESIGNATE_REPAIRER":
        route = `/designate-parties/${task.taskId}`;
        break;
      case "STEP_CONFIRM_PAYMENT":
        route = `/confirm_payment/${task.taskId}`;
        break;
      case "STEP_VALIDATE_INVOICE":
        route = `/invoice-validation/${task.taskId}`;
        break;
      case "STEP_REPARATION_MISSION_ACCEPTANCE":
        route = `/reparation-mission-acceptance/${task.taskId}`;
        break;
      case "STEP_SERVICE_PROPOSAL":
        route = `/service-proposal/${task.taskId}`;
        break;
      case "STEP_ENTER_CUSTOMER_TEL":
        route = `/customer-num-tel/${task.taskId}`;
        break;
      case "STEP_UPLOAD_QUOTATION":
      case "STEP_UPLOAD_INVOICE":
        route = `/upload-quotation-invoices/${task.taskId}`;
        break;
      case "STEP_CLIENT_PART_INFORMATION":
            route = `/client-part-payment/${task.taskId}`;
            break;
      case "STEP_CLIENT_PART_INFORMATION_AFRIQUEASSISTANCE":
            route = `/client-part-payment-partner/${task.taskId}`;
            break;
      case "STEP_CLIENT_PART_CALCULATION":
            route = `/client-part-payment-calculation/${task.taskId}`;
            break;
      case "STEP_UPLOAD_INVOICE_AND_PICTURES":
            route = `/upload-invoice-and-pictures/${task.taskId}`;
            break;
      case "STEP_REPARATION_ENTRY_DATE_INDICATION":
            route = `/reparation-entry-date-indication/${task.taskId}`;
            break;
      case "STEP_CAR_EXIT_VOUCHER_GENERATION" :
            route = `/car-exit-voucher-generation/${task.taskId}`;
            break;
      case "STEP_ENTER_REPAIRSHOP_PAYMENT" :
            route = `/send-RepairShop-payment/${task.taskId}`;
            break;
      case "STEP_UPLOAD_PAYMENT_PROOF" :
            route = `/upload-quittance/${task.taskId}`;
            break;
      case "STEP_UPLOAD_PICTURE_BEFORE_REP":
            route = `/upload-pictures-before-repair/${task.taskId}`;
            break;
      default:
        route = `/todo-list/${task.taskId}`;
    }
    navigate(route);
  };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = taskList.map((n) => n.taskId);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    function getDateFromString(dateString) {
        if (!dateString) return "";
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        //     return `${day}/${month}/${year}`;
        return `${year}-${month}-${day}`;
    }

    function convertToDayMonthYear(dateString) {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
    }

    function renderField(field) {
        return field ? field : <span className={classes.naText}>N/A</span>;
    }

    // number of selected rows
    const numSelected = selected.length;

    const handleDateChange = (e, type) => {
        const dateValue = e.target.value;
        if (type === 'from') {
            setDateRange({ ...dateRange, fromDate: dateValue });
        } else {
            setDateRange({ ...dateRange, toDate: dateValue });
        }
        setPage(0);
    };
 
    function orderByCreationDate(dataArray) {
        return dataArray.sort((a, b) => { 
            const dateA = new Date(a.creationDate);
            const dateB = new Date(b.creationDate);
             return dateB - dateA ;
        });
    }

    
    // Server-side filtering is now handled in fetchData

    const fetchEventsForTasks = async () => {
        try {
            const response = await dispatch(fetchMessageEvents('STEP_SERVICE_PROPOSAL'));
            const events = {};
    
            for (const task of taskList) {
                events[task.taskId] = response?.filter(event => event.relatedEntity === task.businessKey) || [];
            }
    
            setMessageEvents(events);
        } catch (error) {
            const events = taskList.reduce((acc, task) => {
                acc[task.taskId] = [];
                return acc;
            }, {});
            setMessageEvents(events); // Fallback in case of error
        }
    };

    const handleDropdownClick = (taskId) => {
        setCurrentTaskId(taskId);
        setDropdownVisible(!dropdownVisible);
    };

    const handleTaskAction = async (taskId, assignee) => {
        if (assignee === null) {
            await dispatch(claimTask(taskId, username));
        } else {
            await dispatch(unclaimTask(taskId, username));
        }
    };

    const tasksInfo = taskList?.filter(task => task.assignee === username || task.assignee === null);

    const serviceProposal =  tasksInfo?.filter(task => task.taskDefinitionId === "STEP_SERVICE_PROPOSAL").length;
    const designatedParties =  tasksInfo?.filter(task => task.taskDefinitionId === "STEP_DESIGNATE_PARTIES" || task.taskDefinitionId === "STEP_DESIGNATE_INSPECTOR" || task.taskDefinitionId === "STEP_DESIGNATE_REPAIRER").length;
    const clientTel =  tasksInfo?.filter(task => task.taskDefinitionId === "STEP_ENTER_CUSTOMER_TEL").length;
    const reparationMissionAcceptance =  tasksInfo?.filter(task => task.taskDefinitionId === "STEP_DESIGNATE_INSPECTOR").length;
    const uploadQuotation =  tasksInfo?.filter(task => task.taskDefinitionId === "STEP_UPLOAD_QUOTATION").length;
    const clientPartCalculation = tasksInfo?.filter(task =>task.taskDefinitionId === "STEP_CLIENT_PART_INFORMATION").length; 
    const clientPartCalculationAfriqueAssistance = tasksInfo?.filter(task =>task.taskDefinitionId === "STEP_CLIENT_PART_INFORMATION_AFRIQUEASSISTANCE").length; 
    const uploadInvoiceAndPictures =  tasksInfo?.filter(task => task.taskDefinitionId === "STEP_UPLOAD_INVOICE_AND_PICTURES").length;
    const reparationEntryDateIndication =  tasksInfo?.filter(task => task.taskDefinitionId === "STEP_REPARATION_ENTRY_DATE_INDICATION").length;
    const carExitVoucherGeneration =  tasksInfo?.filter(task => task.taskDefinitionId === "STEP_CAR_EXIT_VOUCHER_GENERATION").length;
    const validateReglements =  tasksInfo?.filter(task => task.taskDefinitionId === "STEP_VALIDATE_REGLEMENTS").length;
    const calculatePart =  tasksInfo?.filter(task => task.taskDefinitionId === "STEP_CLIENT_PART_CALCULATION").length;
    const addPaymentProof =  tasksInfo?.filter(task => task.taskDefinitionId === "STEP_UPLOAD_PAYMENT_PROOF").length;
    const confirmPayment =  tasksInfo?.filter(task => task.taskDefinitionId === "STEP_ENTER_REPAIRSHOP_PAYMENT").length;


    const filterTasksByTaskDefinitionId = (taskDefinitionId) => {
        setTaskName(Array.isArray(taskDefinitionId) ? taskDefinitionId[0] : taskDefinitionId);
        setPage(0);
    };
        const DESIGNATE_STEPS = [
        'STEP_DESIGNATE_INSPECTOR',
        'STEP_DESIGNATE_REPAIRER',
        'STEP_DESIGNATE_PARTIES',
        ];
      const sections = [
        { authority: 'VIEW_SERVICE_PROPOSAL_FILTER', id: 'STEP_SERVICE_PROPOSAL', label: 'Proposition de service de prise en charge', data: serviceProposal },
        { authority: 'VIEW_ENTER_CUSTOMER_TEL_FILTER', id: 'STEP_ENTER_CUSTOMER_TEL', label: 'Mise à jour du tél du client', data: clientTel },
        { authority: 'VIEW_DESIGNATE_PARTIES_FILTER', id: DESIGNATE_STEPS, label: 'Désignation expert et/ou réparateur', data: designatedParties },
        { authority: 'VIEW_REPARATION_MISSION_ACCEPTANCE_FILTER', id: 'STEP_DESIGNATE_INSPECTOR', label: 'Désignation Expert', data: reparationMissionAcceptance },
        { authority: 'VIEW_UPLOAD_QUOTATION_FILTER', id: 'STEP_UPLOAD_QUOTATION', label: 'Ajout devis réparateur', data: uploadQuotation },
        { authority: 'VIEW_CALCULATE_PART_FILTER', id: 'STEP_CLIENT_PART_CALCULATION', label: 'Calcul part client', data: calculatePart },
        { authority: 'VIEW_CLIENT_PART_CALCULATION_FILTER', id: 'STEP_CLIENT_PART_INFORMATION', label: 'Contact client', data: clientPartCalculation },
        { authority: 'VIEW_CLIENT_PART_CALCULATION_FILTER_AF', id: 'STEP_CLIENT_PART_INFORMATION_AFRIQUEASSISTANCE', label: 'Calcul part et contact client', data: clientPartCalculationAfriqueAssistance },
        { authority: 'VIEW_REPARATION_ENTRY_DATE_INDICATION_FILTER', id: 'STEP_REPARATION_ENTRY_DATE_INDICATION', label: 'Indication du début des réparations', data: reparationEntryDateIndication },
        { authority: 'VIEW_UPLOAD_INVOICE_AND_PICTURES_FILTER', id: 'STEP_UPLOAD_INVOICE_AND_PICTURES', label: 'Ajout photos et factures', data: uploadInvoiceAndPictures },
        { authority: 'VIEW_CAR_EXIT_VOUCHER_GENERATION_FILTER', id: 'STEP_CAR_EXIT_VOUCHER_GENERATION', label: 'Génération du bon de sortie', data: carExitVoucherGeneration },
        { authority: 'VIEW_VALIDATE_REGLEMENTS_FILTER', id: 'STEP_VALIDATE_REGLEMENTS', label: 'Valider réglements expert et/ou garage', data: validateReglements },
        { authority: 'VIEW_UPLOAD_PAYMENT_PROOF_FILTER', id: 'STEP_UPLOAD_PAYMENT_PROOF', label: 'Ajout quittance', data: addPaymentProof },
        { authority: 'VIEW_REPAIRSHOP_PAYMENT_FILTER', id: 'STEP_ENTER_REPAIRSHOP_PAYMENT', label: 'Saisie Honoraires Réparateur', data: confirmPayment },
    ];

    const fetchData = async () => {
        setLoading(true);
        try {
            const filters = {
                createdStartDate: dateRange.fromDate,
                createdEndDate: dateRange.toDate,
                claimId: claimNumber,
                immatriculation: immatriculation.toUpperCase(),
            };
            const response = await dispatch(getTasksForUser(username, userGroups, page + 1, rowsPerPage, filters));
            
            if (response && response.data && response.data.pagination) {
                const { total, page: serverPage, limit } = response.data.pagination;
                // If we are on a page that is now out of bounds due to filters,
                // the server might return page 1 or the last valid page.
                // We sync our local page state (0-indexed) with the server (1-indexed).
                if (serverPage - 1 !== page) {
                    setPage(serverPage - 1);
                }
            }
        } finally {
            setLoading(false);
        }
    };

    
    function handleRequestSort(event, property) {
        const isDesc = orderBy === property && order === "desc";
        setOrder(isDesc ? "asc" : "desc");
        setOrderBy(property);
    }
     

    
    useEffect(() => {
        if (!username) return;
        fetchData();
    }, [dispatch, username, page, rowsPerPage, dateRange, claimNumber, immatriculation]);
 
 
     return (
        <div className={classes.root}>
              
            {/* <div className={classes.todoListActions}>
                {userGroups.includes('FULL_ACCESS_GROUP') ? (
                    <div
                        style={{cursor: 'pointer', fontSize: '0.8rem', display: 'flex', justifyContent: 'center',marginRight: '2rem', alignItems: 'center', color: 'rgb(60, 101, 86)'}}
                        className={classes.todoSection}
                    >
                         
                    </div>
                ) : (
                    <>
                        {sections.map((section, index) =>
                            hasAuthorities(section.authority) && (
                                <div
                                    key={section.id}
                                    style={{cursor: 'pointer'}}
                                    className={`${classes.todoSection} ${index === 0 ? classes.firstSection : ''} ${index === sections.length - 1 ? classes.lastSection : ''}`}
                                    onClick={() => filterTasksByTaskDefinitionId(section.id)}
                                >
                                    {section.label}
                                    <span className={classes.sectionText}>{section.data}</span>
                                    <span className={classes.sectionLine}></span>
                                </div>
                            )
                        )}
                    </>
                )}
                            
                    
           
            </div> */}
            <Paper className={classes.paper}>
                <div className={classes.tableWrapper}>
                    <div style={{display: 'flex', alignItems: 'center', marginBottom: '40px'}}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <div className={classes.titre} style={{marginRight: '15px'}}>Filtrer par</div>
                            <div className={classes.titreLabel}
                                 style={{display: 'flex', alignItems: 'center', marginRight: '15px'}}>
                                Date
                                <div
                  className={classes.dateRangeContainer}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "15px",
                    height: "29px",
                  }}
                >
                  <span style={{ marginRight: "5px" }}>De</span>
                  <input
                    type={inputType}
                    className={classes.dateContainer}
                    placeholder=""
                    onFocus={() => setInputType("date")}
                    onBlur={() => setInputType("text")}
                    style={{ width: "110px", height: "29px" }}
                    onChange={(e) => handleDateChange(e, "from")}
                  />
                  <span style={{ marginRight: "1px" }}>A</span>
                  <input
                    type={inputType}
                    className={classes.dateContainer}
                    placeholder=""
                    onFocus={() => setInputType("date")}
                    onBlur={() => setInputType("text")}
                    style={{ width: "110px", height: "29px" }}
                    onChange={(e) => handleDateChange(e, "to")}
                  />
                </div>
                            </div>
                            {/* <div className={classes.titreLabel}
                                 style={{display: 'flex', alignItems: 'center', marginRight: '10px'}}>
                                Responsable
                                <select className={classes.inputContainer}
                                        style={{width: '10rem', marginLeft: '10px'}}
                                        // value={responsible}
                                        onChange={(e) => setResponsible(e.target.value)}
                                >
                                    <option className={classes.optionItem} value=""></option>
                                    {uniqueResponsibles.map((name, index) => (
                                        <option className={classes.optionItem}  key={index} value={name}>{name}</option>
                                    ))}
                                </select>
                            </div> */}
                            {/*<div className={classes.titreLabel}*/}
                            {/*     style={{display: 'flex', alignItems: 'center', marginRight: '10px'}}>*/}
                            {/*    Action*/}
                            {/*    <select className={classes.inputContainer}*/}
                            {/*            style={{width: '10rem', marginLeft: '10px'}}*/}
                            {/*            onChange={(e) => setTaskName(e.target.value)}*/}
                            {/*    >*/}
                            {/*        <option className={classes.optionItem}  value=""></option>*/}
                            {/*        {uniqueTaskNames.map((name, index) => (*/}
                            {/*            <option className={classes.optionItem} key={index} value={name}>*/}
                            {/*                {translateTaskName(name)}*/}
                            {/*            </option>*/}
                            {/*        ))}*/}
                            {/*    </select>*/}
                            {/*</div>*/}
                            <div className={classes.titreLabel} style={{display: 'flex', alignItems: 'center'}}>
                                N° Sinistre
                                <input
                                    type="text"
                                    className={classes.inputContainer}
                                    style={{width: '10rem', marginLeft: '10px'}}
                                    onChange={(e) => {
                                        setClaimNumber(e.target.value);
                                        setPage(0);
                                    }}
                                    list="claimNumbers"
                                />
                            </div>
                            <div className={classes.titreLabel} style={{marginLeft: '30px' ,display: 'flex', alignItems: 'center'}}>
                                Immatriculation
                                <input
                                    type="text"
                                    className={classes.inputContainer}
                                    style={{width: '10rem', marginLeft: '10px'}}
                                    onChange={(e) => {
                                        setImmatriculation(e.target.value);
                                        setPage(0);
                                    }}
                                    list="immatriculation"
                                />
                            </div>
                        </div>
                    </div>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size="small"
                    >
                        <EnhancedTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={taskList?.length}
                            numSelected={numSelected}
                            onSelectAllClick={handleSelectAllClick}
                        />
                        {loading ?(
                            <TableBody>
                                {[...Array(10)].map((row, index) => {
                                    return (
                                        <tr
                                            hover
                                            style={{height: "48px"}}
                                        >
                                            <TableCell
                                                align="left"
                                                className={classes.tableCellSmall}
                                            >
                                                <Skeleton animation="wave"/>
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                className={classes.tableCellSmall}
                                            >
                                                <Skeleton animation="wave"/>
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                className={classes.tableCellSmall}
                                            >
                                                <Skeleton animation="wave"/>
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                className={classes.tableCellSmall}
                                            >
                                                <Skeleton animation="wave"/>
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                className={classes.tableCellSmall}
                                            >
                                                <Skeleton animation="wave"/>
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                className={classes.tableCellSmall}
                                            >
                                                <Skeleton animation="wave"/>
                                            </TableCell>
                                            <TableCell align="right" className={classes.tableCellSmall}
                                                           style={{ borderBottom: 'none' }}>
                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                        <button className={classes.viewBtn} >
                                                            <BsThreeDots />
                                                        </button>
                                                        <button className={classes.viewBtn} style={{marginLeft: '7px'}}>
                                                        <AiOutlineEye/>
                                                        </button>
                                                    </div>
                                                </TableCell>
                                        </tr>
                                    );
                                })}
                            </TableBody>
                           ) : (
                            <>
                              {" "}
                            {taskList != null && taskList.length > 0 ? (
                            <TableBody>
                                {taskList
                                    .map((task, index) => {
                                        const isItemSelected = selected.indexOf(task.taskId) !== -1;
                                        const labelId = `enhanced-table-checkbox-${index}`;
                                        const backgroundColor = index % 2 === 0 ? 'rgb(255, 255, 255)' : 'rgba(250, 250, 250, 1)';
                                        const events = messageEvents[task.taskId] || [];

                                          return (
                                            <tr
                                                hover
                                                key={task.taskId || index}
                                                style={{height: "70px", backgroundColor: backgroundColor}}
                                                selected={isItemSelected}
                                            >
                                               
                                                <TableCell align="left" className={classes.tableCellSmall}
                                                           style={{ borderBottom: 'none' }}
                                                >
                                                    <div className={classes.sinistres}>
                                                        {renderField(task.businessKey)}
                                                    </div>
                                                </TableCell>
                                                <TableCell align="left" className={classes.tableCellSmall}
                                                           style={{ borderBottom: 'none' }}
                                                >
                                                    <div className={classes.sinistres}>
                                                        {renderField(task.variables?.immatriculation?.value)}
                                                    </div>
                                                </TableCell>
                                                <TableCell align="left" className={classes.tableCellSmall}
                                                           style={{ borderBottom: 'none' }}
                                                >
                                                    <div className={classes.tableContent}>
                                                        {renderField(task.assignee)}
                                                    </div>
                                                </TableCell>
                                                <TableCell align="left" className={classes.tableCellSmall}
                                                           style={{ borderBottom: 'none' }}
                                                >
                                                    <div className={classes.tableContent} style={{ display: 'flex', justifyContent: 'left' }}>
                                                        {task.variables?.managementType?.value ? (
                                                            <Chip 
                                                                label={task.variables.managementType.value}
                                                                className={classes.managementTypeChip}
                                                                size="small"
                                                            />
                                                        ) : (
                                                            <span className={classes.naText}>N/A</span>
                                                        )}
                                                    </div>
                                                </TableCell>
                                                <TableCell align="left" className={classes.tableCellSmall}
                                                           style={{ borderBottom: 'none' }}
                                                >
                                                    <div className={classes.tableContent}>
                                                        {renderField(getDateTimeFromString((task.creationDate?.toString())))}
                                                    </div>
                                                </TableCell>
                                                
                                                <TableCell align="left" className={classes.tableCellSmall} style={{ borderBottom: 'none' }}>
                                                    <div
                                                        style={{
                                                            height: "26px",
                                                            borderRadius: "51px",
                                                            background: "rgba(240, 243, 199, 1)",
                                                            textAlign: "center",
                                                            padding: "5px",
                                                            fontFamily: "Poppins",
                                                            fontSize: "10.17px",
                                                            fontWeight: 500,
                                                            lineHeight: "15.26px",
                                                            color: "rgba(60, 101, 86, 1)",
                                                        }}
                                                    >
                                                        {renderField(translateTaskName(task.taskName))}
                                                        {events.length > 0 && (
                                                            <span >
                                                                {events.map((event, index) => (
                                                                    <div key={index} style={{color:"rgba(255, 168, 0, 1)",fontWeight:"700", marginTop:"10px"}}>
                                                                         <span>{event.body}</span>
                                                                    </div>
                                                                ))}
                                                            </span>
                                                        )}
                                                    </div>
                                                </TableCell>
                                                <TableCell align="right" className={classes.tableCellSmall}
                                                           style={{ borderBottom: 'none' }}
                                                >
                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                        <button className={classes.viewBtn} onClick={() => handleDropdownClick(task.taskId)}>
                                                            <BsThreeDots />
                                                            {dropdownVisible && currentTaskId === task.taskId && (
                                                                <div className={classes.dropdownMenu}>
                                                                    <div className={classes.dropdownItem}
                                                                         onClick={() => handleTaskAction(task.taskId, task.assignee)}>
                                                                        {task.assignee === null ? "Claim Task" : "Unclaim Task"}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </button>
                                                        <button className={classes.viewBtn} style={{marginLeft: '7px'}}
                                                                onClick={() => handleViewClick(task)}
                                                        >
                                                        <AiOutlineEye/>
                                                        </button>
                                                    </div>
                                                </TableCell>
                                            </tr>
                                          );
                                        })}
                            </TableBody>
                            ):(
                                <TableBody>
                                  <TableCell
                                      align="left"
                                      style={{fontFamily : 'Poppins', fontWeight : 400 ,fontSize :15, lineHeight:'22.5px' ,color :'rgba(70, 78, 95, 1)' , padding :'20px' }}
                                      colspan="6"
                                  >
                                    {" "}
                                    Aucune action disponible
                                  </TableCell>
                                </TableBody>
                            )} {" "}
                            </>
                       ) }
                    </Table>
               
                <TablePagination
                    rowsPerPageOptions={[10, 20, 30]}
                    component="div"
                    count={pagination?.total || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        "aria-label": "Previous Page",
                    }}
                    nextIconButtonProps={{"aria-label": "Next Page",}}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    style={{
                        fontFamily: "Poppins",
                        fontSize: "12px",
                        fontWeight: 400,
                        lineHeight: "18px",
                        color: "rgba(32, 18, 70, 1)",
                      }}
                      labelRowsPerPage="Lignes par page"
                />
             </div>
            </Paper>

        </div>
    )
}
